<div [class]="'wrapper-container ' + type">
    <span class="label"
        >{{ label }}
        @if (required) {
            <span class="label required">*</span>
        }
        @if (info) {
            <mat-icon
                [matTooltip]="info"
                matTooltipClass="field-wrapper-tooltip-class"
                class="info-icon"
                fontSet="material-symbols-outlined"
                >info</mat-icon
            >
        }
    </span>

    @if (textContent) {
        <div class="text-content">
            {{ textContent }}
        </div>
    }

    <ng-content></ng-content>
</div>
